export default __webpack_public_path__ + "static/media/ic_chad.0c22a7c0.svg";